import { useState } from 'react'

//TODO-MIGRATION
import { useAppSelector } from 'src/v2/store/hooks'

import withErrorBoundaryAndPolicyCheck from '../../../v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import Sidebar from './Sidebar'
import Topbar from './Topbar'
import styles from './basic-template-wrapper.module.scss'

import Portal from '@v2/commons/components/ResponsivePortal/ResponsivePortal.component'
import useDocumentTitle from '@v2/commons/hooks/useDocumentTitle.hook'
import SwitchOrganizationButton from '@v2/domains/organization/components/SwitchOrganizationButton/SwitchOrganizationButton.component'
import SearchField from '@v2/domains/person/components/search/SearchField.component'
import { selectOrganizations } from '@v2/domains/user/selectors/user.selectors'

const BasicTemplateWrapper = (props: React.PropsWithChildren) => {
  const { children } = props
  useDocumentTitle('')

  const organizationsByUser = useAppSelector(selectOrganizations)

  const [showMobileSidebar, setShowMobileSidebar] = useState<boolean>(false)

  return (
    <>
      <div className={styles.wrapper}>
        <Sidebar
          showMobile={showMobileSidebar}
          onClose={() => setShowMobileSidebar(false)}
        />

        <div className={styles.inner}>
          <Topbar
            onBurgerToggle={() => setShowMobileSidebar(!showMobileSidebar)}
          >
            {organizationsByUser.length > 1 ? (
              <SwitchOrganizationButton />
            ) : null}

            <Portal.Target
              data-testid="person-search-desktop-card"
              className={styles.desktopSearch}
              id="searchField"
              media="desktop"
            />
          </Topbar>
          {children}
        </div>
      </div>

      <SearchField />
    </>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  BasicTemplateWrapper,
  'is_enable_basic_template_wrapper',
  true,
)
